module.exports = __webpack_public_path__ + "img/foot-sm-img.24266933.png";